var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5548 1.79742C10.8179 1.53433 11.2445 1.53433 11.5076 1.79742L14.2023 4.49215C14.4654 4.75524 14.4654 5.1818 14.2023 5.44489L5.4444 14.2028C5.31806 14.3291 5.1467 14.4001 4.96803 14.4001H2.27329C1.90123 14.4001 1.59961 14.0985 1.59961 13.7264V11.0317C1.59961 10.853 1.67059 10.6817 1.79693 10.5553L10.5548 1.79742ZM2.94698 11.3107V13.0527H4.68898L12.7732 4.96852L11.0312 3.22652L2.94698 11.3107Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53377 3.81847C8.79686 3.55538 9.22341 3.55538 9.4865 3.81847L12.1812 6.5132C12.4443 6.77629 12.4443 7.20285 12.1812 7.46594C11.9181 7.72903 11.4916 7.72903 11.2285 7.46594L8.53377 4.7712C8.27068 4.50811 8.27068 4.08156 8.53377 3.81847Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerEdit);
export default __webpack_public_path__ + "static/media/customerEdit.2f26615f05b840714514047c4e626864.svg";
export { ForwardRef as ReactComponent };